import { FrontWebRadioModel} from "../../../generated";
import ListCss from "../List.module.scss";
import { RadioBox} from "../../Item/Radio/RadioBox";
import {useIsSafari} from "../../../contexts/useIsSafari";

export const RadioBoxList = (props : {
    items: FrontWebRadioModel[],
    className?: string
}) => {
    const isSafari = useIsSafari();
    return <ul className={`d-flex justify-content-start flex-wrap ${ListCss.UlBox} ${props.className ?? ""}`}>
        {props.items.map((item, k) => (
            <li key={k} className={`${ListCss.LiBox} ${isSafari.noGap ? ListCss.LiBoxSafari : ""}`}>
                <RadioBox radio={item}/>
            </li>)
        )}</ul>
}